// extracted by mini-css-extract-plugin
export default {"pinButton":"styles_pinButton__6ebE6"};